import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" api="extension-version" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static String extensionVersion();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`String signalExtensionVersion = Signal.extensionVersion();
`}</code></pre>
    <Variant platform="ios" api="extension-version" repeat="7" mdxType="Variant" />
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`(nonnull NSString*) extensionVersion;
`}</code></pre>
    <p><strong parentName="p">{`Examples`}</strong></p>
    <p><strong parentName="p">{`Swift`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`var signalExtensionVersion  = ACPSignal.extensionVersion()
`}</code></pre>
    <p><strong parentName="p">{`Objective-C`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`NSString *signalExtensionVersion = [ACPSignal extensionVersion];
`}</code></pre>
    <Variant platform="react-native" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPSignal.extensionVersion().then(signalExtensionVersion => console.log("AdobeExperienceSDK: ACPSignal version: " + signalExtensionVersion));
`}</code></pre>
    <Variant platform="flutter" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "dart"
    }}>{`Dart`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`String signalExtensionVersion = await FlutterACPSignal.extensionVersion;
`}</code></pre>
    <Variant platform="cordova" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "cordova"
    }}>{`Cordova`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPSignal.extensionVersion(function(version) {  
    console.log("ACPSignal version: " + version);
}, function(error) {  
    console.log(error);  
});
`}</code></pre>
    <Variant platform="unity" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "c"
    }}>{`C#`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`string signalVersion = ACPSignal.ExtensionVersion();
`}</code></pre>
    <Variant platform="xamarin" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "c-1"
    }}>{`C#`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`string signalVersion = ACPSignal.ExtensionVersion();
`}</code></pre>
    <Variant platform="android" api="register-extension" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-1"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void registerExtension()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Signal.registerExtension();
`}</code></pre>
    <Variant platform="ios" api="register-extension" repeat="7" mdxType="Variant" />
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`+ (void) registerExtension;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p><strong parentName="p">{`Swift`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPSignal.registerExtension()
`}</code></pre>
    <p><strong parentName="p">{`Objective-C`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`[ACPSignal registerExtension];
`}</code></pre>
    <Variant platform="react-native" api="register-extension" repeat="1" mdxType="Variant" />
    <p>{`When using React Native, register the Signal extension with Mobile Core in native code as shown on the Android and iOS tabs.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      